var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{model:{value:(_vm.localHandleOpenModalsImage),callback:function ($$v) {_vm.localHandleOpenModalsImage=$$v},expression:"localHandleOpenModalsImage"}},[_c('div',{staticClass:"zoom-in-wrapper"},[_c('ZoomImage',{attrs:{"imageSrc":_vm.photoDetail,"isOneImage":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }